// views/Admin/Statistics/components/Table/Table.tsx
import { useEffect, useState, useCallback } from 'react';
import Loading from '../../../../../components/common/Loading/Loading';
import { Statistics } from '../../../../../Entities';
import styles from './Table.module.css';

interface TableProps {
  tableName: string;
}

const TABLE_LABELS: Record<string, string> = {
  total_amounts: '💰 Celkové částky',
  bonus_history: '🎁 Historie bonusů',
  recent_users: '👥 Aktivita uživatelů',
};

const prettify = (name: string) =>
  TABLE_LABELS[name] ?? name.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export default function Table({ tableName }: TableProps) {
  const [table, setTable] = useState<Record<string, any[]> | null>(null);
  const [loading, setLoading] = useState(true);

  const getTable = useCallback(async () => {
    try {
      setTable(await Statistics.get(tableName));
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [tableName]);

  useEffect(() => {
    getTable();
  }, [getTable]);

  if (loading) return <Loading />;
  if (!table) return <h1>Fetch error</h1>;

  const columns = Object.keys(table);
  const rowCount = table[columns[0]]?.length || 0;

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>
        {prettify(tableName)}
        <span className={styles.count}>{rowCount}</span>
      </h2>

      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr className={styles.headerRow}>
              {columns.map((column) => (
                <th key={column} className={styles.headerCell}>
                  {column.replace(/_/g, ' ')}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rowCount === 0 ? (
              <tr>
                <td className={styles.emptyState} colSpan={columns.length || 1}>
                  Žádná data k zobrazení
                </td>
              </tr>
            ) : (
              Array.from({ length: rowCount }).map((_, rowIndex) => (
                <tr
                  key={rowIndex}
                  className={styles.row}
                  style={{ background: rowIndex % 2 === 0 ? 'var(--card)' : 'var(--bg-warm)' }}
                >
                  {columns.map((column) => (
                    <td key={`${rowIndex}-${column}`} className={styles.bodyCell}>
                      {table[column][rowIndex]}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
